module.exports = "<highcharts-chart \n[Highcharts]=\"Highcharts\"\n[options]=\"chartOptions2\"\nstyle=\"width: 100%; height: 400px; display: block;\"\n></highcharts-chart>"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/users/donut-chart/donut-chart.component.html
// module id = ../../../../../src/app/users/donut-chart/donut-chart.component.html
// module chunks = main